import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { MeterConfigurationData } from "../../../ThirdPartySystems.types";

function getRotorsoftColumns(): Array<MRT_ColumnDef<MeterConfigurationData>> {
  return [
    { header: "Windparks", accessorKey: "parameters.windparkName" },
    {
      header: "Anlagenname",
      accessorKey: "parameters.plantName",
      minSize: 140
    },
    {
      header: "Hersteller",
      accessorKey: "parameters.manufacturer",
      Cell: ({ renderedCellValue }) => renderedCellValue || "Unbekannt"
    },
    { header: "Anlagenkennung", accessorKey: "parameters.plantId" },
    {
      header: "Seriennummer",
      accessorKey: "parameters.serialNumber",
      minSize: 150
    },
    {
      header: "Name des Modells",
      accessorKey: "parameters.modelName",
      Cell: ({ renderedCellValue }) => renderedCellValue || "Unbekannt"
    },
    {
      header: "Installierte Leistung",
      accessorKey: "parameters.modelNominalPower",
      Cell: ({ row }) =>
        "modelNominalPower" in row.original.parameters &&
        (row.original.parameters.modelNominalPower.includes("None")
          ? "0 kW"
          : row.original.parameters.modelNominalPower)
    }
  ];
}

export { getRotorsoftColumns };
